import React from 'react'
export default class InputMap extends React.Component {
  render () {
    return "地图选址"
  }
}
